const subRouter = '/v3/';
export default subRouter